<script setup lang="ts">
import lodashIsNumber from 'lodash-es/isNumber';

import { SellingMethod, AuctionState, DirectSaleComputedState } from '~/apiClient';
import { type PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<PlatformSaleItemEntity>, required: true },
});

// EMITS
defineEmits<{
    triggerOpen: [];
}>();

// COMPOSABLES
const { tt, tn } = useTypedI18n();

// DATA
const price = computed(() => (sale?.sellingMethod === SellingMethod.Auction ? sale.currentPrice : sale.price));

const showPrice = computed(() => {
    if (sale?.sellingMethod === SellingMethod.Auction) {
        return sale.state === AuctionState.Running;
    }

    if (sale?.sellingMethod === SellingMethod.DirectSale) {
        return sale.computedState === DirectSaleComputedState.NoActiveOrder;
    }

    return false;
});
</script>

<template>
    <div class="space-y-4 p-4">
        <p v-if="lodashIsNumber(price) && showPrice" class="text-primary text-2xl font-semibold">{{ tn(price, 'currency') }}</p>
        <UButton size="lg" :label="tt('sdp.bottomSheet.openSheetCta')" block @click="$emit('triggerOpen')" />
    </div>
</template>
